<template>
    <div class="container_table_main_table main_table">
        <div class="counterpart_table_header">
            <div class="search_container">
                <p class="absolute-box is-flex is-justify-content-flex-start is-align-items-center">
                    <span class="ml-3 mr-1">
                        <SearchIcon class="icon_svg" />
                    </span>

                    <input class="input-center" type="text" :placeholder="selectedTypeFile.searcherPlaceHolder"
                        v-model="searchFilter" />
                    <span class="icon-right mr-3" @click="searchFilter = ''">
                        <Ecs v-if="searchFilter" class="icon is-small is-right ecs" />
                    </span>
                </p>
            </div>
        </div>
        <table class="is-full-width color_gray_text" style="table-layout: fixed;">
            <colgroup>
                <col v-for="header in selectedTypeFile.headers" v-bind:key="header.orderKey"
                    :style="getColumnWidth(header)" />
                <col style="width: 120px;" />
            </colgroup>
            <tr class="sticky_table_header">
                <td class="py-3 px-2" v-for="header in selectedTypeFile.headers" v-bind:key="header.orderKey">
                    <span class="table_header_title is-justify-content-center nobreak">
                        {{ header.label }}
                        <SortButton @click="changeOrderGeneric(header.orderKey)" class="ml-1"
                            :globalSortColumn="sortColumn" :column="header.orderKey" :sortDirection="sortDirection">
                        </SortButton>
                    </span>
                </td>
                <td class="py-3 px-2">
                    <span class="table_header_title is-justify-content-center nobreak">
                        Acciones
                    </span>
                </td>
            </tr>
            <template v-for="(entry) in filteredTaxDocs">
                <tr :class="['row', { 'is-disabled-local': entry.cancelled }]" v-show="entry.visible" :key="entry.id">
                    <template v-for="header in selectedTypeFile.headers">
                        <td v-bind:key="header.orderKey" v-if="!['account', 'mother_account'].includes(header.orderKey)"
                            class="py-3 px-2 text_format has-text-centered nobreak">
                            <span v-if="header.orderKey == 'emitted_at'" class="is-capitalized">
                                {{ getFormattedDate(entry.emitted_at, header.formatDate) }}
                            </span>
                            <span v-else-if="header.orderKey == 'amount'">
                                {{ toMoney(getNestedValue(entry, header.nestedPath)) }}
                            </span>
                            <div v-else class="has-tooltip-top is-flex is-justify-content-center"
                                :data-tooltip="getNestedValue(entry, header.nestedPath)">
                                <span class="truncate-text">
                                    {{ getNestedValue(entry, header.nestedPath) }}
                                </span>
                            </div>
                        </td>
                    </template>

                    <td class="py-3 px-2 text_format has-text-centered">
                        <div class="square_pill pill_sin_clasificar nobreak"
                            v-if="!entry.prorate_accounts || entry.prorate_accounts.length == 0">
                            <span v-if="!entry.cancelled">Sin Clasificar</span>
                            <span v-if="entry.cancelled && entry.doc_type != 'Boleta de Honorarios'">
                                Anulado por NC: {{ entry.nc_doc_number }}
                            </span>
                            <span v-if="entry.cancelled && entry.doc_type == 'Boleta de Honorarios'">
                                Anulada
                            </span>
                        </div>
                        <div v-if="entry.prorate_accounts && entry.prorate_accounts.length > 0"
                            class="is-flex is-flex-direction-column is-align-items-center" style="gap: 4px;">
                            <span class="square_pill pill_mother_account grey_pill nobreak"
                                v-for="(mother_account, index) in getUniqueMotherAccounts(entry.prorate_accounts)"
                                v-bind:key="index">
                                {{ mother_account }}
                            </span>
                        </div>
                    </td>
                    <td class="py-3 px-2 text_format has-text-centered">
                        <div v-if="entry.prorate_accounts && entry.prorate_accounts.length > 0"
                            class="is-flex is-flex-direction-column is-align-items-center" style="gap: 4px;">
                            <div class="square_pill pill_mother_account white_pill nobreak"
                                v-for="account in getUniqueAccounts(entry.prorate_accounts)" v-bind:key="account">
                                {{ account }}
                            </div>
                        </div>
                        <div v-if="!entry.cancelled && (!entry.prorate_accounts || entry.prorate_accounts.length == 0)"
                            class="is-full-width is-flex is-justify-content-center">
                            <span class="square_pill pill_clasificar is-clickable"
                                @click="openAccountByCompanyModal(entry)">
                                <EditPencil class="edit_pencil" />
                                Clasificar
                            </span>
                        </div>
                    </td>
                    <td class="py-3 px-2 has-text-centered">
                        <div class="is-flex is-justify-content-center is-align-items-center" style="gap: 1px;">
                            <!-- <span v-if="selectedTypeFile.value != 'finiquitos-clf' && !entry.cancelled" 
                                  class="is-clickable is-flex icon-action" 
                                  title="Clasificar" 
                                  @click="openAccountByCompanyModal(entry)">
                                <EditPencil class="edit_pencil_action" />
                            </span> -->
                            <span v-if="selectedTypeFile.value != 'finiquitos-clf' && !entry.cancelled"
                                class="is-clickable is-flex icon-action has-tooltip-top" data-tooltip="Editar Datos"
                                @click="openEditDocumentModal(entry)">
                                <EditPencil class="edit_pencil_action_orange" />
                            </span>
                            <span class="is-clickable is-flex icon-action has-text-danger has-tooltip-top"
                                data-tooltip="Eliminar" @click="$emit('deleteEntry', entry)">
                                <Trash class="trash_action" />
                            </span>
                        </div>
                    </td>
                </tr>
            </template>

        </table>
    </div>
</template>

<script>
import ClassifyAccountAttributes from "@/components/modals/ClassifyAccountAttributes";
import EditDocumentModal from "@/components/modals/EditDocumentModal.vue";
import SortButton from "@/components/modals/SortButton.vue";
import Ecs from "@/components/svg/Ecs.vue";
import EditPencil from "@/components/svg/EditPencil.vue";
import SearchIcon from "@/components/svg/SearchIcon.vue";
import Trash from "@/components/svg/Trash.vue";
import { parseToMoney } from "@/utils/currency";
import { notificate } from "@/utils/message";
import { editTaxDocument } from "@/api/uploadFiles";
import moment from "moment";
import { mapState } from "vuex";

export default {
    name: "RemunerationsDocsTable",
    components: {
        SortButton,
        SearchIcon,
        Ecs,
        EditPencil,
        Trash
    },
    data() {
        return {
            searchFilter: '',
            sortColumn: '',
            sortDirection: '',
            modalDefault: {
                parent: this,
                hasModalCard: true,
                customClass: "modal-class",
                canCancel: ["escape", "outside"],
            },
            localOrderedTaxDocuments: [],
        }
    },
    computed: {
        ...mapState("classification", ["periodDataSelect"]),
        ...mapState("uploadFiles", ["selectedTypeFile"]),
        filteredTaxDocs() {
            if (!this.searchFilter) return this.localOrderedTaxDocuments;

            const searchTerms = this.normalizeString(this.searchFilter).split(" ").filter(t => t);
            return this.localOrderedTaxDocuments.filter(entry => {
                let searchableValues = [];
                if (this.selectedTypeFile?.headers) {
                    this.selectedTypeFile.headers.forEach(header => {
                        if (header.nestedPath) {
                            searchableValues.push(this.getNestedValue(entry, header.nestedPath));
                        }
                    });
                }
                searchableValues.push(entry.amount, entry.description, entry.companies_involved?.alias, entry.companies_involved?.counterpart?.rut);

                const searchableText = this.normalizeString(searchableValues.join(" "));
                return searchTerms.every(term => searchableText.includes(term));
            })
        }
    },
    methods: {
        normalizeString(str) {
            if (str === null || str === undefined) return '';
            return String(str).normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase();
        },
        getColumnWidth(header) {
            if (header.orderKey === 'emitted_at') {
                return 'width: 120px;';
            }

            // Sum all relative widths from headers except 'emitted_at'
            let totalMiddleWidth = 0;
            this.selectedTypeFile.headers.forEach(h => {
                if (h.orderKey !== 'emitted_at') {
                    totalMiddleWidth += Number(h.width) || 0;
                }
            });

            if (totalMiddleWidth === 0) return 'width: auto;';

            // Calculate ratio and use CSS calc to distribute the exact remaining space (100% - 240px for both 120px extremes)
            const ratio = (Number(header.width) || 0) / totalMiddleWidth;
            return `width: calc((100% - 240px) * ${ratio});`;
        },
        toMoney: (value) => {
            return parseToMoney(value);
        },
        getFormattedDate(emittedDate, format = 'DD-MM-YYYY') {
            if (!emittedDate) return '';
            return moment(emittedDate).format(format).replace('.', '');
        },
        getNestedValue(obj, path) {
            if (!path || !obj) return '';
            return path.split('.').reduce((val, key) => (val && val[key] !== undefined ? val[key] : ''), obj)
        },
        openEditDocumentModal(document) {
            this.$buefy.modal.open({
                ...this.modalDefault,
                component: EditDocumentModal,
                props: {
                    document: document,
                    headers: this.selectedTypeFile.headers
                },
                events: {
                    save: async (formData, resolve, reject) => {
                        try {
                            const payload = {};
                            if (formData.amount !== undefined) payload.amount = formData.amount;
                            if (formData.description !== undefined) payload.description = formData.description;
                            if (formData.doc_number !== undefined) payload.document_number = formData.doc_number;

                            // Handling counterpart updates
                            if (formData.rut !== undefined || formData.name_counterpart !== undefined) {
                                payload.counterpart = {
                                    rut: formData.rut || this.getNestedValue(document, "companies_involved.counterpart.rut"),
                                    name: formData.name_counterpart || this.getNestedValue(document, "companies_involved.alias")
                                };
                            }

                            await editTaxDocument({ document_id: document.id, field: payload });
                            notificate(
                                `<strong>Éxito!</strong><br>
                                Documento actualizado exitosamente`,
                                "is-success is-light"
                            );
                            this.$emit('reloadData');
                            resolve();
                        } catch (error) {
                            console.error("Error al actualizar documento", error);
                            notificate(
                                `<strong>Error!</strong><br>
                                Ocurrió un error al actualizar los datos`,
                                "is-danger is-light"
                            );
                            reject();
                        }
                    }
                }
            });
        },
        openAccountByCompanyModal(document) {
            try {
                const contraparte = {
                    ci_id: document.companies_involved?.id,
                    pay_or_charge: document.document_type,
                    obligation_name: this.selectedTypeFile?.value
                }
                let rangeMain = 'last12'

                this.$buefy.modal.open({
                    ...this.modalDefault,
                    component: ClassifyAccountAttributes,
                    customClass: "classify_modal_width",
                    props: {
                        rangeFromMainScreen: rangeMain,
                        counterpart: contraparte,
                    },
                    events: {
                        reloadCounterpart: () => {
                            this.$emit('reloadData')
                        },
                    },
                });
            } catch (err) {
                console.log("error?:", err);
            }
        },
        getUniqueMotherAccounts(prorateAccounts) {
            if (!prorateAccounts || !Array.isArray(prorateAccounts)) return [];
            let motherAccounts = []
            prorateAccounts.forEach(pr => {
                const motherAcc = pr?.account_plan?.level_21?.level_2;
                if (motherAcc && motherAccounts.indexOf(motherAcc) < 0) {
                    motherAccounts.push(motherAcc)
                }
            })
            return motherAccounts
        },
        getUniqueAccounts(prorateAccounts) {
            if (!prorateAccounts || !Array.isArray(prorateAccounts)) return [];
            let accounts = []
            prorateAccounts.forEach(pr => {
                const acc = pr?.account_plan?.level_3;
                if (acc && accounts.indexOf(acc) < 0) {
                    accounts.push(acc)
                }
            })
            return accounts
        },
        changeDirectionData() {
            if (this.sortDirection == "order") {
                this.sortDirection = "desc";
            } else if (this.sortDirection == "desc") {
                this.sortDirection = "asc";
            } else if (this.sortDirection == "asc") {
                this.sortDirection = "order";
                this.sortColumn = "order";
            }
        },
        sortPartiallyDocs(docsToSort = []) {
            if (!this.sortColumn || this.sortDirection === "order") {
                return docsToSort;
            }

            const headerDef = this.selectedTypeFile?.headers?.find(h => h.orderKey === this.sortColumn);
            const nestedPath = headerDef ? headerDef.nestedPath : this.sortColumn;

            return docsToSort.sort((a, b) => {
                let valA = headerDef ? this.getNestedValue(a, nestedPath) : a[this.sortColumn];
                let valB = headerDef ? this.getNestedValue(b, nestedPath) : b[this.sortColumn];

                if (valA === undefined || valA === '') valA = a[this.sortColumn];
                if (valB === undefined || valB === '') valB = b[this.sortColumn];

                if (valA === null || valA === undefined) valA = '';
                if (valB === null || valB === undefined) valB = '';

                let result = 0;

                if (this.sortColumn === 'amount' || typeof valA === 'number') {
                    result = Number(valA) - Number(valB);
                } else if (this.sortColumn === 'emitted_at') {
                    result = new Date(valA).getTime() - new Date(valB).getTime();
                } else if (this.sortColumn === 'doc_number') {
                    const strA = String(valA);
                    const strB = String(valB);
                    const maskedA = strA.padStart(Math.max(strA.length, strB.length), "0");
                    const maskedB = strB.padStart(Math.max(strA.length, strB.length), "0");
                    result = maskedA.localeCompare(maskedB);
                } else if (this.sortColumn === 'accounts') {
                    const getAccountLevel3 = (obj, val) => {
                        if (Array.isArray(val) && val.length > 0) return val[0].level_3 || '';
                        return obj.accounts_doc || '';
                    };
                    const auxA = getAccountLevel3(a, valA);
                    const auxB = getAccountLevel3(b, valB);
                    result = String(auxA).localeCompare(String(auxB));
                } else {
                    result = String(valA).localeCompare(String(valB));
                }

                if (result === 0) {
                    const amountA = Number(a.amount) || 0;
                    const amountB = Number(b.amount) || 0;
                    result = amountA - amountB;
                }

                return this.sortDirection === "asc" ? result : -result;
            });
        },
        sortAllDocuments() {
            if (!this.tax_documents) return;
            const documentsClassified = this.tax_documents.filter(localDoc => localDoc.prorate_accounts && localDoc.prorate_accounts.length > 0 && !localDoc.cancelled)
            const documentsNotClassified = this.tax_documents.filter(localDoc => (!localDoc.prorate_accounts || localDoc.prorate_accounts.length == 0) && !localDoc.cancelled)
            const documentsAnnulled = this.tax_documents.filter(localDoc => localDoc.cancelled)
            const orderedDocsClassified = this.sortPartiallyDocs(documentsClassified)
            const orderedDocsNotClassified = this.sortPartiallyDocs(documentsNotClassified)
            const orderedDocsAnnulled = this.sortPartiallyDocs(documentsAnnulled)
            this.localOrderedTaxDocuments = [...orderedDocsNotClassified, ...orderedDocsClassified, ...orderedDocsAnnulled]
        },
        changeOrderGeneric(column) {
            if (this.sortColumn != column) {
                this.sortDirection = "order"
                this.sortColumn = column;
            }
            this.changeDirectionData();
            this.sortAllDocuments();
        },
    },
    mounted() {
        this.changeOrderGeneric('amount')
    },
    props: ["tax_documents"],
    watch: {
        tax_documents() {
            this.searchFilter = ''
            this.sortColumn = ''
            this.sortDirection = ''
            this.changeOrderGeneric('amount')
        }
    }
}
</script>

<style lang="scss" scoped>
.container_table_main_table {
    border-radius: 8px;
    overflow-x: auto;
    overflow-y: auto;
    border: 1px solid #eaecf0;
    max-height: 70vh;
    scrollbar-width: none;
}

.main_table {
    border-collapse: collapse;
    min-height: 10vh;
    max-height: 50vh;
    min-width: max(100%, 800px);
}

.icon_svg {
    margin-bottom: -4px;
}

.counterpart_table_header {
    background-color: #eaecf0;
    height: 60px;
    width: 100%;
    padding: 12px 20px;
    align-items: center;
    border-top-right-radius: 8px;
    border-top-left-radius: 8px;
    position: sticky;
    top: 0;
    z-index: 20;

    .search_container {
        border-radius: 8px;
        box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
        max-width: fit-content;

        .absolute-box {
            background-color: white;
            border-radius: 8px;

            .input-center {
                z-index: 2;
                border-width: 0;
                width: 300px;
                height: 35px;
                background-color: transparent;
            }

            .input-center:focus {
                outline: none;
                border-color: transparent;
                box-shadow: none;
            }

            .icon-right {
                height: 20px;
                right: 0px;
                left: auto;
            }
        }
    }
}

.sticky_table_header td {
    position: sticky;
    top: 60px;
    z-index: 10;
    background-color: #fcfcfd;
    border-bottom: 1px solid #eaecf0;
}

.color_gray_text {
    color: #475467;
}

.table_header_title {
    font-weight: 500;
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: #fcfcfd;
    box-sizing: border-box;
    text-align: left;
    font-size: 12px;
}

.square_pill {
    position: relative;
    border-radius: 6px;
    box-sizing: border-box;
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    gap: 3px;
    justify-content: center;
    padding: 2px 4px;
    text-align: center;
    font-size: 12px;
    width: min-content;
    min-width: 4em;
}

.pill_sin_clasificar {
    color: #344054;
    background-color: #f9fafb;
    border: 1px solid #eaecf0;
    font-weight: 500;
    line-height: 18px !important;
    font-size: 12px;
}

.pill_mother_account {
    line-break: auto;
    color: #475467;
    font-weight: 500;
    line-height: 18px !important;
    font-size: 12px;
}

.grey_pill {
    background-color: #eaecf0;
    border: 1px solid #d0d5dd;
}

.white_pill {
    background-color: #FFF;
    border: 1px solid #D0D5DD;
}

.pill_clasificar {
    position: relative;
    box-shadow: 0px 1px 8px rgba(16, 24, 40, 0.05);
    border-radius: 8px;
    background-color: #fef3f2;
    border: 1px solid #fecdca;
    box-sizing: border-box;
    width: 103px;
    overflow: hidden;
    flex-shrink: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 8px 12px;
    gap: 4px;
    text-align: left;
    font-size: 12px;
    color: #b42318;
    font-family: Inter;
    font-weight: 600;
}

.row {
    border-top: 1px solid #eaecf0;
    margin-bottom: 10px;

    .text_format {
        color: var(--Gray-600, #475467);
        font-size: 12px;
        font-weight: 500;
        line-height: 20px;
    }

    td {
        vertical-align: middle;
    }
}

.truncate-text {
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
}

.icon-action {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 6px;
    border: 1px solid transparent;
    transition: all 0.2s;

    &:hover {
        border-radius: 6px;
        border: 1px solid #00A9AD;
        background-color: #EFFEFD;
    }
}

.edit_pencil {
    filter: invert(19%) sepia(91%) saturate(2972%) hue-rotate(348deg) brightness(85%) contrast(98%);
}

.edit_pencil_action {
    width: 18px;
    height: 18px;
    filter: invert(32%) sepia(20%) saturate(629%) hue-rotate(182deg) brightness(96%) contrast(87%);
}

.trash_action {
    width: 18px;
    height: 18px;
    filter: invert(27%) sepia(87%) saturate(2763%) hue-rotate(346deg) brightness(88%) contrast(97%);
}

.edit_pencil_action_orange {
    width: 18px;
    height: 18px;
    filter: invert(62%) sepia(88%) saturate(2758%) hue-rotate(1deg) brightness(104%) contrast(96%);
}
</style>